import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import AppShell from "./layouts/AppShell";
import { Skeleton } from "./components/UI";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import WebsitesPage from "./pages/WebsitesPage";
import WebsiteDetailPage from "./pages/WebsiteDetailPage";
import KnowledgePage from "./pages/KnowledgePage";
import ChatbotPage from "./pages/ChatbotPage";
import AnalyticsPage from "./pages/AnalyticsPage";
import SettingsPage from "./pages/SettingsPage";
import ProfilePage from "./pages/ProfilePage";
import NotFoundPage from "./pages/NotFoundPage";
import WebsiteSelector from "./components/WebsiteSelector";

function Protected() {
  const { admin, loading } = useAuth();
  if (loading)
    return (
      <div className="boot-screen">
        <span className="brand-mark">K</span>
        <Skeleton rows={3} />
      </div>
    );
  return admin ? <AppShell /> : <Navigate to="/login" replace />;
}
export default function App() {
  const { admin } = useAuth();
  return (
    <Routes>
      <Route
        path="/login"
        element={admin ? <Navigate to="/" replace /> : <LoginPage />}
      />
      <Route element={<Protected />}>
        <Route index element={<DashboardPage />} />
        <Route path="websites" element={<WebsitesPage />} />
        <Route path="websites/:id" element={<WebsiteDetailPage />} />
        <Route
          path="knowledge"
          element={
            <WebsiteSelector
              destination="knowledge"
              title="Choose a knowledge base"
              description="Knowledge is isolated by website. Select a tenant to review its records and versions."
            />
          }
        />
        <Route
          path="websites/:websiteId/knowledge"
          element={<KnowledgePage />}
        />
        <Route
          path="chatbot"
          element={
            <WebsiteSelector
              destination="chatbot"
              title="Choose a chatbot"
              description="Select a website to configure its assistant and preview the visitor experience."
            />
          }
        />
        <Route path="websites/:websiteId/chatbot" element={<ChatbotPage />} />
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route
          path="websites/:websiteId/analytics"
          element={<AnalyticsPage />}
        />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
